<!--
@Author: Tom Voorneveld <tom>
@Date:   2019-05-16T16:35:54+02:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2019-05-17T11:19:51+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:

// props of this component set the default for SocialSharing

<social-sharer
  id="sm-icons-top"
  :scale="1.1"
  :title="$t('title.slogan')"
  description="Puck by Qrespi - Touch to Care"
  quote=""
  hashtags="care, seniors"
  twitter-user="qrespi"
  class="pl-2 d-none d-lg-block"/>
-->

<template>
  <div>
    <b-modal
      id="sm-modal"
      header-bg-variant="secondary"
      header-text-variant="white"
      size="sm"
      :title="$t('contact.socialmedia.share')"
      ok-only>
      <social-sharing
        :twitter-user="smData.twitterUser || twitterUser"
        :url="smData.url || url"
        :title="smData.title || title"
        :description="smData.description || description"
        :quote="smData.quote || quote"
        :hashtags="smData.hashtags || hashtags"
        inline-template>
        <ul class="social-sharing-modal">
          <li><network network="email"><icon name="envelope" :scale="1.5"/>Email</network></li>
          <li><network network="facebook"><icon name="brands/facebook-f" :scale="1.5"/>Facebook</network></li>
          <!-- <li><network network="googleplus"><icon name="brands/google-plus" scale="1.5"/>Google +</network></li> -->
          <!-- <li><network network="line"><icon name="brands/line" scale="1.5"/>Line</network></li> -->
          <li><network network="linkedin"><icon name="brands/linkedin-in" :scale="1.5"/>LinkedIn</network></li>
          <!-- <li><network network="odnoklassniki"><icon name="brands/odnoklassniki" scale="1.5"/>Odnoklassniki</network></li> -->
          <li><network network="pinterest"><icon name="brands/pinterest" :scale="1.5"/>Pinterest</network></li>
          <li><network network="reddit"><icon name="brands/reddit" :scale="1.5"/>Reddit</network></li>
          <li><network network="skype"><icon name="brands/skype" :scale="1.5"/>Skype</network></li>
          <!-- <li><network network="sms"><icon name="commenting-o" scale="1.5"/>SMS</network></li> -->
          <li><network network="telegram"><icon name="brands/telegram" :scale="1.5"/>Telegram</network></li>
          <li><network network="twitter"><icon name="brands/twitter" :scale="1.5"/>Twitter</network></li>
          <!-- <li><network network="vk"><icon name="brands/vk" scale="1.5"/>VKontakte</network></li> -->
          <!-- <li><network network="weibo"><icon name="brands/weibo" scale="1.5"/>Weibo</network></li> -->
          <li><network network="whatsapp"><icon name="brands/whatsapp" :scale="1.5"/>Whatsapp</network></li>
        </ul>
      </social-sharing>
      <!-- <small>
        quote: {{quote}} / {{smData.quote}} / {{ smData.quote || quote }}<br>
        url: {{url}} / {{smData.url}} / {{ smData.url || url }}<br>
        title: {{title}} / {{smData.title}} / {{ smData.title || title }}<br>
        description: {{description}} / {{smData.description}} / {{ smData.description || description }}<br>
        hashtags: {{hashtags}} / {{smData.hashtags}} / {{ smData.hashtags || hashtags }}<br>
        twitter-user: {{twitterUser}} / {{smData.twitterUser}} / {{ smData.twitterUser || twitterUser }}
      </small> -->

      <h5 v-html="$t('contact.socialmedia.follow')"/>
      <div class="sm-links">
        <span
          v-for="i in 3"
          :key="i"
          class="iconlink"
          @click="navigateTo(smLinks[i-1].url)">
          <icon :scale="1.5" :name="smLinks[i-1].icon"/>
        </span>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import SocialSharing from 'vue-social-sharing'

Vue.use(SocialSharing)

export default {
  name: 'SocialSharingModal',
  props: {
    // default values that SocialShareButton can/should override
    twitterUser: { type: String, default: 'yourTwitterUser' },
    title: { type: String, default: 'Your share title' },
    url: { type: String, default: window.location.href },
    description: { type: String, default: 'Description from SocialShare.vue' },
    quote: { type: String, default: 'Your default quote' },
    hashtags: { type: String, default: 'a, few, hastags' }
  },
  data: function () {
    return {
      smData: {},
      smLinks: [
        {
          icon: 'brands/twitter',
          url: 'https://twitter.com/qrespi'
        },
        // { icon: 'brands/twitter',
        //   url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.tweet)}&url=${encodeURIComponent(QRESPIURL)}`
        // },
        {
          icon: 'brands/facebook-f',
          url: 'https://www.facebook.com/qrespi/'
        },
        // { icon: 'brands/facebook-f',
        //   url: `https://www.facebook.com/sharer/sharer.php?u=${QRESPIURL}`
        // },
        {
          icon: 'brands/linkedin-in',
          url: 'https://www.linkedin.com/company/qrespi/'
        }
      ]
    }
  },
  methods: {
    navigateTo: function (nav) {
      console.log(`Go ${nav}`)
      window.open(nav, '_blank')
    }
  },
  mounted () {
    this.$root.$on('sm_share', data => {
      this.smData = data
    })
  }
}
</script>

<style lang="scss">
#sm-modal {
  .social-sharing-modal {
    padding: 0;
    list-style-type: none;
    li {
      margin-bottom: 8px;
      cursor: pointer;
      span {
        color: $info !important;
        font-size: 1.25em;
        line-height: 1;
        .fa-icon {
          margin-right: 8px;
          width: 2em;
        }
      }
    }
    li:hover {
      color: $primaryHighlight;
      font-weight: bold;
    }
  }
  .sm-links {
    display: inline-block;
    display: inline-flex;
    margin-left: 20px;
    min-width: 60px;
    .iconlink {
      cursor: pointer;
      white-space: nowrap;
      color: $info;
      &:not(:first-child) {
        padding-left: 1em;
      }
    }
    .iconlink:hover {
      color: $primaryHighlight;
    }
  }

}

</style>
